import { render, staticRenderFns } from "./CreditsAndAdditionalInfo.vue?vue&type=template&id=419ed6b4"
import script from "./CreditsAndAdditionalInfo.vue?vue&type=script&lang=js"
export * from "./CreditsAndAdditionalInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports